// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import createBrowserHistory from 'history/createBrowserHistory';

export const browserHistory = createBrowserHistory();



// WEBPACK FOOTER //
// ./utils/browser_history.jsx